import { render, staticRenderFns } from "./sysTemplate.vue?vue&type=template&id=0f172535&scoped=true"
import script from "./sysTemplate.vue?vue&type=script&lang=js"
export * from "./sysTemplate.vue?vue&type=script&lang=js"
import style0 from "./sysTemplate.vue?vue&type=style&index=0&id=0f172535&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f172535",
  null
  
)

export default component.exports